import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../../api';

// 1. The "Library" function (internal to this file)
const fetchProjects = async (tenantId) => {
    return await apiRequest(`/api/projects/${tenantId}`, {
    method: 'POST', // Explicitly set POST to match Flask
    body: JSON.stringify({}), // Send an empty object if no data is needed
  });  
};
export const useProjects = (tenantId) => {
  return useQuery({
    queryKey: ['projects', tenantId],
    queryFn: () => fetchProjects(tenantId),
    enabled: !!tenantId, // Only run if we actually have an ID!
  });
};